import { init as sentryInit } from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import { appConfig } from 'utils/app-config'
import {
  isProductionEnvironment,
  isStagingEnvironment
} from 'utils/environment'

export function canInitSentry(): boolean {
  return isStagingEnvironment() || isProductionEnvironment()
}

export function initSentry() {
  if (!canInitSentry()) {
    return
  }

  const { RAVEN_DSN } = appConfig.getState()
  const { BRANCH, COMMIT_REF, REACT_APP_CIRCLE_BRANCH, REACT_APP_CIRCLE_SHA1 } =
    process.env

  try {
    sentryInit({
      dsn: RAVEN_DSN,
      environment: REACT_APP_CIRCLE_BRANCH || BRANCH || 'development',
      release: REACT_APP_CIRCLE_SHA1 || COMMIT_REF,
      ignoreErrors: [
        // error will cause a retry and still results in a usable application, so don't log this EN-2251
        'Chunk Load Error',
        // benign/ignorable error according to spec author
        // https://stackoverflow.com/a/50387233
        'ResizeObserver loop limit exceeded'
      ],
      // omit tracing in staging
      ...(isProductionEnvironment() && {
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0
      })
    })
  } catch (err) {
    console.error('Unable to initialize Sentry:', err)
  }
}
